import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExpandSection = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "icon icon-tabler icons-tabler-outline icon-tabler-fold-down",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "none",
			d: "M0 0h24v24H0z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M12 11v8l3 -3m-6 0l3 3" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 7l1 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 7l1 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M19 7l1 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M4 7l1 0" })
	]
});
export default SvgExpandSection;
